<template>
  <div class="create-import">
    <div class="create-import__title">Create New Import</div>
    <label class="create-import__input">
      <span class="create-import__label">Import Type</span>
      <div class="create-import__link-wrapper" :class="{'create-import__link-wrapper_single': isDomainDropdownHidden}">
          <base-select
            border-less="true"
            class="create-import__active"
            :class="{'form-control_error': externalErrors.pivot_table}"
            :options="opts.types"
            v-model="pivot_table"
            alignLeft="true"
            :max-height-list="450"
            :titleStyle="{ overflow: 'visible' }"
            :headerStyle="selectTypeStyle"
          />
          <span class="create-import__error-message" v-if="externalErrors.pivot_table">{{externalErrors.pivot_table}}</span>
      </div>
    </label>
     <label class="create-import__input">
      <span class="create-import__label">File</span>
      <div class="create-import__link-wrapper" :class="{'create-import__link-wrapper_single': isDomainDropdownHidden}">
        <input type="file"
            @change="fileChange($event.target.files[0])"
            :class="{'form-control_error': externalErrors.file}"
            >
        <span class="create-import__error-message" v-if="externalErrors.file">{{externalErrors.file}}</span>
      </div>
    </label>
    <div class="create-import__controls">
      <button class="create-import__button create-import__button_cancel"
              @click.prevent="close()">Cancel
      </button>
      <button class="create-import__button create-import__button_submit"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'
import _ from 'lodash'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}
const TYPES_OPTIONS = [
  {
    value: -1,
    label: '---- Not Selected ----'
  },
  {
    value: 0,
    label: 'Keyword Data Import'
  },
  {
    value: 1,
    label: 'Rank Report Data'
  },
  {
    value: 2,
    label: 'URL Data Import'
  },
  {
    value: 3,
    label: 'Writer Access Data Import'
  }
]
export default {
  name: 'CreateImportPopup',
  mixins: [BaseModalMixins],
  data () {
    return {
      pivot_table: -1,
      file: null,
      externalErrors: {
        pivot_table: null,
        file: null
      },
      selectTypeStyle: { ...SELECT_STYLE },
      // should domain name selector be hidden or not
      isDomainDropdownHidden: true
    }
  },
  computed: {
    isCurrentUserAgent () {
      return this.currentUser &&
        (this.userRoles.includes('agency_user') || this.userRoles.includes('agency_admin')) &&
        !this.userRoles.includes('admin')
    },
    opts () {
      return {
        types: this.isCurrentUserAgent ? _.cloneDeep(TYPES_OPTIONS).filter(i => i.value != 1) : _.cloneDeep(TYPES_OPTIONS)
      }
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    apply () {
      const form = new FormData()
      if (this.file) {
        form.append('file', this.file, this.file.name)
        form.append('pivot_table', this.pivot_table)
        this.$emit('apply', form)
      }
    },
    fileChange (file) {
      this.file = file
    }
  }
}
</script>

<style lang="scss">
  .create-import {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-top: 30px;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__label {
      display: block;
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }

    &__link {
      &-wrapper {
        position: relative;
        margin-top: 30px;

        &_single{
          margin-top: 0;
        }
      }

      &-field[type='text'] {
        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
      }
    }

    &__error-message {
        color: $rfx-red;
        font-size: 10px;
        margin-top: 5px;
      }
  }

  .form-control {
    height: 50px;
    padding: 0 20px;
    border: 2px solid $rfx-light-steel;
    outline: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: $rfx-dark-march;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &:disabled {
      background-color: $rfx-light-steel;
    }

    &_error{
       border-color: $rfx-red;
      color: $rfx-red;

       &::placeholder {
         color: $rfx-red;
         font-size: 13px;
       }

     }
  }

</style>
